<template>
    <div id="country-select" class="flex flex-col w-full">
        <DropdownField
            ref="dropdownRef"
            :field="countryField"
            :step-data="stepData"
            :has-error="false"
            :angle-down-solid="angleDownSolid"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DropdownField from './BuyVignette/components/DropDownField.vue';
import { resolveDefaultVehicleCountryCode } from '../utils/languageDefaultCountry.js';

const CODE_TO_SLUG = {
    BE: 'belgium',
    NL: 'netherlands',
    DE: 'germany',
    FR: 'france',
    IT: 'italy',
    ES: 'spain',
    GB: 'uk',
    AT: 'austria',
    PL: 'poland',
    CH: 'switzerland',
    PT: 'portugal',
    SCANDINAVIA: 'scandinavia'
};

const SLUG_ORDER = ['belgium', 'netherlands', 'germany', 'france', 'italy', 'spain', 'uk', 'austria', 'poland', 'switzerland', 'portugal'];
const SCANDINAVIA_CODES = ['SE', 'NO', 'DK', 'FI'];

export default {
    name: 'PaymentMethodsCountrySelect',
    components: { DropdownField },
    props: {
        angleDownSolid: { type: [String, Object], default: null }
    },
    data() {
        return {
            stepData: { plate_country: '' }
        };
    },
    computed: {
        ...mapGetters('form', ['countries']),
        countryField() {
            const list = [];
            const seen = new Set();
            const bySlug = {};
            (this.countries || []).forEach(c => {
                const slug = CODE_TO_SLUG[c.code];
                if (slug && slug !== 'scandinavia' && !bySlug[slug]) bySlug[slug] = c;
            });
            SLUG_ORDER.forEach(slug => {
                const c = bySlug[slug];
                if (c) {
                    list.push({
                        code: c.code,
                        translated: { name: (c.translated?.name || c.code || '').trim() },
                        flag: c.flag || ''
                    });
                    seen.add(c.code);
                }
            });
            (this.countries || []).forEach(c => {
                const slug = CODE_TO_SLUG[c.code];
                if (slug && slug !== 'scandinavia' && !seen.has(c.code)) {
                    list.push({
                        code: c.code,
                        translated: { name: (c.translated?.name || c.code || '').trim() },
                        flag: c.flag || ''
                    });
                    seen.add(c.code);
                }
            });
            const nordic = (this.countries || []).find(c => SCANDINAVIA_CODES.includes(c.code));
            if (nordic) {
                list.push({
                    code: 'SCANDINAVIA',
                    translated: { name: 'Scandinavia (Sweden, Norway, Denmark, Finland)' },
                    flag: nordic.flag || ''
                });
            }
            return {
                key: 'plate_country',
                translated: { label: '' },
                options: list
            };
        }
    },
    watch: {
        'stepData.plate_country'(code) {
            if (!code) return;
            const slug = CODE_TO_SLUG[code] || code.toLowerCase();
            if (typeof window.showCountryMethods === 'function') {
                window.showCountryMethods(slug);
            }
        },
        countries() {
            this.applyDefaultCountry();
        }
    },
    created() {
        this.applyDefaultCountry();
    },
    mounted() {
        this.$store.dispatch('form/loadInitialData').catch(() => {});
        this.applyDefaultCountry();
    },
    methods: {
        applyDefaultCountry() {
            if (this.stepData.plate_country || !this.countryField.options.length) return;
            const langCode = this.$store.getters.lang?.code;
            const code = resolveDefaultVehicleCountryCode(langCode, this.countryField.options);
            if (!code) return;
            this.stepData.plate_country = code;
            const slug = CODE_TO_SLUG[code] || code.toLowerCase();
            if (typeof window.showCountryMethods === 'function') window.showCountryMethods(slug);
        }
    }
};
</script>
